export default "__VITE_ASSET__BzcmBzdy__"